define('models/FeaturesModel',[
    'evertrue',
    'jquery',
    'underscore',
    'backbone',
    'ET/ETModel'
], function FeaturesModelFactory (EverTrue, $, _, Backbone, ETModel) {

    // This model determines what console features are availble to users based on
    // 1. Org Product Name (DNA.ET.Org.Products)
    // 2. Org Product Extra features
    // 3. User role (for super admin pages)

    var FeaturesModel = ETModel.extend({

        // -----------------------------------------------------------------------------
        // CONFIGURE FEATURES
        // Add a feature name to the appropriate object, for features with
        // sub navigations, include all items as "parent:child"
        // -----------------------------------------------------------------------------

        // Features that are available to all users
        defaults: {
            features: [
                "importer",
                "notifications",
                "flex_data"
            ]
        },

        // Features that are gated by product & level
        product_features: {
            community: {
                standard: [
                    "setup",
                    "growth",
                    "growth:resources",
                    "growth:facebook_ads",
                    "design",
                    "content",
                    "content:social",
                    "content:custom",
                    "login_requests",
                    "manage_records",
                    "reporting",
                    "reporting:growth",
                    "reporting:engagement",
                    "reporting:suggested_updates",
                    "reporting:email_leads",
                    "reporting:linkedin",
                    "users"
                ],
                premium: []
            },
            givingtree: {standard: []}
        },

        // Features that are gated by user roles
        role_features: {
            super_user: [
                "settings",
                "user_mgmt",
                "dna_editor",
                "roles",
                "flex_data"
            ]
        },

        // -----------------------------------------------------------------------------
        // MODEL METHODS
        // -----------------------------------------------------------------------------

        initialize: function() {
            var self = this;
            this.listenTo(EverTrue.DNA, 'change', function(){
                self.set({features: self.defaults.features}, {silent: true});
                self.init();
            });
        },

        // init() sets the model "features" attribute to an array
        // of features available to the current user & org
        // @params {options} - passed into set method for calling `silent`
        init: function(options) {
            var self = this,
                data = _.clone(self.get('features')),
                access = self.getAccess();

            _.each(access, function(rule){
                var isPremium = rule.match(":premium");
                if (self.product_features[rule] || isPremium) {
                    if (isPremium) {
                        rule = rule.split(":")[0];
                        data.push(self.product_features[rule].premium);
                    }
                    data.push(self.product_features[rule].standard);
                } else if (self.role_features[rule]) {
                    data.push(self.role_features[rule]);
                } else {
                    data.push(rule);
                }
            });

            self.set({features: _.flatten(_.uniq(data))}, options);
        },

        // getAccess will return a list of groups that a user has access to
        // example: ['community', "community:premium", "reporting", "super_user"]
        getAccess: function() {
            var products = EverTrue.DNA.get("ET.Org.Products")
                access = [];

            _.each(products, function(prod){
                access.push(prod.name);
                if (prod.premium) access.push(prod.name + ":premium");
            });

            if (EverTrue.User.get("super_user")) access.push("super_user");
            return _.compact(_.flatten(access));
        },

        // getParents will return all features that have children,
        // which are denoted in the config as "parent:child"
        // Used for pages with sub navigations
        getParents: function() {
            var self = this,
                parents = [];

            _.each(self.get("features"), function(feat){
                if (feat.match(":")) {
                    parents.push(feat.split(":")[0]);
                }
            });

            return _.uniq(parents);
        },

        // getChildrenFor will return all children of {parent}
        // Used for pages with sub navigations
        getChildrenFor: function(parent) {
            var self = this,
                features = [];

            features = _.filter(self.get("features"), function(feature) {
                return feature.match(parent + ":");
            });

            return features;
        }

    });

    return FeaturesModel;
});


